module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAQCAYAAAC1MDndAAAAjUlEQVRYhe2X0QqAMAhFM/r/X658KOTiuAOJhXqeGhVsB70yOW+2Zsi+egN/pwURWhDhWL2BrxGR9xnj1r6z2O9SC1IB9rC4VtiMKtViKmNUNSNSV9AMKAwrqpQgr3q8XCqTQdhS3pqRWpASvSiUCmlkJrDTC7ISvDFP/69wWX0keUdlU6yEoAjpWyzKBR0+PBsrlOYeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/qhtb1-1.png
// module id = 703
// module chunks = 0